import { render, staticRenderFns } from "./RoadlogInfo.vue?vue&type=template&id=48621a7d&"
import script from "./RoadlogInfo.vue?vue&type=script&lang=js&"
export * from "./RoadlogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports